import React from "react";
import { Routes, Route, Link, NavLink } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { NarrativeProvider } from "./contexts/NarrativeContext";
import { TournamentProvider } from "./contexts/TournamentContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SoundProvider } from "./contexts/SoundContext";
import "./index.css";

// AIDEV-NOTE: Main App component with routing using CVA styles
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <SoundProvider>
        <TournamentProvider>
          <NarrativeProvider>
            <div className="min-h-screen">
              {/* Routes */}
              <Routes>
                <Route path="/" element={<HomePage />} />
              </Routes>
            </div>
          </NarrativeProvider>
        </TournamentProvider>
      </SoundProvider>
    </ThemeProvider>
  );
};

export default App;
